import React from 'react';
import { HiOutlineMail } from "react-icons/hi";
// Assuming NPSNLogo is imported correctly in your file (e.g., import NpsnLogo from './path/to/NpsnLogo.png';)

const Footer = ({ NpsnLogo }) => {
  // Define the navigation items for easy maintenance
  const navItems = [
    { name: 'Privacy Policy', href: '/privacy-policy' },
    { name: 'Terms & Conditions', href: '/terms' },
  ];

  const currentYear = new Date().getFullYear(); // Dynamically get the current year

  return (
    // Wrapper for the entire footer section
    <footer className="mt-24 w-full border-t border-gray-200 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">


        {/* Navigation and Contact Links */}
        <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-8 text-sm font-semibold mb-6 pb-6">

          {navItems.map((item) => (
            <a
              key={item.name}
              href={item.href}
              className="text-gray-600 hover:text-gray-900 transition duration-300 hover:underline"
            >
              {item.name}
            </a>
          ))}

          {/* Contact Link */}
          <a
            href="mailto:support@intelserve.io"
            className="flex items-center gap-2 text-teal-600 hover:text-teal-500 transition duration-300 font-bold"
          >
            <HiOutlineMail className="text-xl" />
            support@intelserve.io
          </a>
        </div>

        {/* Copyright */}
        <div className="text-center text-xs text-gray-500">
          &copy; {currentYear} IntelServe, All rights reserved.
        </div>

      </div>
    </footer>
  );
};

export default Footer;